'use strict';

import { EventEmitter } from 'events';
import assign from 'object-assign';
import TngAppDispatcher from '../dispatcher/TngAppDispatcher';

import appConstants from 'constants/appConstants';
import processAction from 'services/storeUtils';
import _ from 'underscore';
let _newStarters = [];
let _newStarter = {};
let _workflowStatus;
const _newStartersCompletedPages = {};
let _resendResult;
let _newStarterActionCount = 0;
let _deleteStatuses = {
    errror: null,
    success: false,
    loading: false,
};

let _storeStatuses = {
    errror: null,
    success: false,
    loading: false,
};

const loadNewStarters = function (response) {
    _storeStatuses = processAction(response, function (responseBody) {
        _newStarters = responseBody;
    });
};

const loadMoreNewStarters = function (response) {
    _storeStatuses = processAction(response, function (responseBody) {
        _newStarters.Items = _newStarters.Items.concat(responseBody.Items);
        _newStarters.NextPageLink = responseBody.NextPageLink;
    });
};

const loadNewStarter = function (response) {
    const screenType = response.queryParams.screenType;
    if (!_newStarter[screenType]) {
        _newStarter[screenType] = {};
    }
    const actions = processAction(response, function (responseBody) {
        _newStarter[screenType] = responseBody;
    });

    _newStarter[screenType].statuses = actions;

};

const updateNewStarter = function (response) {
    _storeStatuses = processAction(response);
};

const addNewStarter = function (response) {
    _storeStatuses = processAction(response);
};

const resendForm = function (response) {
    _storeStatuses = processAction(response, function (responseBody) {
        _resendResult = responseBody;
    });    
};

const deleteNewStarter = function (response) {
    _deleteStatuses = processAction(response, responseBody => {
        // _deleteStatuses.success = true;
    });
};

const resetNewStarter = function (response) {
    _newStarter = {};
};

const updateNewStarterStatus = function (response) {
    _storeStatuses = processAction(response);
};

const getNewStarterStatus = function (response) {
    _storeStatuses = processAction(response, function (responseBody) {
        _workflowStatus = responseBody;
    });
};

const getNewStarterCompletedPages = (response, newStarterId) => {
    _storeStatuses = processAction(response, function (responseBody) {
        _newStartersCompletedPages[newStarterId] = responseBody;
    });
};

const getNewStarterActionCount = function (response) {
    _storeStatuses = processAction(response, function (responseBody) {
        _newStarterActionCount = responseBody;
    });
};


const NewStarterStore = assign({}, EventEmitter.prototype, {
    addChangeListener(callback) {
        NewStarterStore.on(appConstants.events.CHANGE, callback);
    },
    removeChangeListener(callback) {
        NewStarterStore.removeListener(appConstants.events.CHANGE, callback);
    },
    addChangeNewStarterCountListener(callback) {
        NewStarterStore.on(appConstants.events.CHANGE_NEW_STARTER_COUNT, callback);  
    },
    removeChangeNewStarterCountListener(callback) {
        NewStarterStore.removeListener(appConstants.events.CHANGE_NEW_STARTER_COUNT, callback);
    }, 
    addAddNewStarterChangeListener(callback) {
        NewStarterStore.on(appConstants.events.ADD_NEW_STARTER, callback);
    },
    removeAddNewStarterChangeListener(callback) {
        NewStarterStore.removeListener(appConstants.events.ADD_NEW_STARTER, callback);
    },
    addDeleteNewStarterChangeListener(callback) {
        NewStarterStore.on(appConstants.events.DELETE_NEW_STARTER, callback);
    },
    removeDeleteNewStarterChangeListener(callback) {
        NewStarterStore.removeListener(appConstants.events.DELETE_NEW_STARTER, callback);
    },
    addNewStarterStatusChangeListener(callback) {
        NewStarterStore.on(appConstants.events.CHANGE_NEW_STARTER_STATUS, callback);
    },
    removeNewStarterStatusChangeListener(callback) {
        NewStarterStore.removeListener(appConstants.events.CHANGE_NEW_STARTER_STATUS, callback);
    },
    addChangeCompletedPagesListener: (callback) => {
        NewStarterStore.on(appConstants.events.CHANGE_NEW_STARTER_COMPLETED_PAGES, callback);
    },
    removeChangeCompletedPagesListener: (callback) => {
        NewStarterStore.removeListener(appConstants.events.CHANGE_NEW_STARTER_COMPLETED_PAGES, callback);
    },
    addChangeActionsCountListener: (callback) => {
        NewStarterStore.on(appConstants.events.CHANGE_NEW_STARTER_ACTIONS_COUNT, callback);
    },
    removeChangeActionsCountListener: (callback) => {
        NewStarterStore.removeListener(appConstants.events.CHANGE_NEW_STARTER_ACTIONS_COUNT, callback);
    },
    addResendFormtoNewStarterListener: (callback) => {
        NewStarterStore.on(appConstants.events.RESEND_FORMS_NEW_STARTER, callback);
    },
    removeResendFormtoNewStarterListener: (callback) => {
        NewStarterStore.removeListener(appConstants.events.RESEND_FORMS_NEW_STARTER, callback);
    },
    getNewStarters() {
        const response = _storeStatuses;
        response.newStarters = _newStarters;
        return response;
    },
    getNewStarter() {
        const response = _storeStatuses;
        response.newStarter = _newStarter;
        return response;
    },
    getNewStarterStatus(id) {
        const response = _storeStatuses;
        response.workflowStatus = _workflowStatus;
        return response;
    },
    getNewStarterCompletedPages(id) {
        const response = _storeStatuses;
        response.completedPages = _newStartersCompletedPages[id];
        return response;
    },
    getDeleteStatuses() {
        return _deleteStatuses;
    },
    getNewStarterActionsCount() {
        const response = _storeStatuses;
        response.actionsCount = _newStarterActionCount;
        return response;
    },
    resendForm() {
        const response = _storeStatuses;
        response.resendresult = _resendResult;
        return response;
    },
});


NewStarterStore.dispatchToken = TngAppDispatcher.register(function (payload) {
    const action = payload.action;
    switch (action.actionType) {
    case appConstants.actions.NEW_STARTERS.GET_NEW_STARTERS_COUNT:
        loadNewStarters(action);
        NewStarterStore.emit(appConstants.events.CHANGE_NEW_STARTER_COUNT);
        break;

    case appConstants.actions.NEW_STARTERS.GET_NEW_STARTERS:
        loadNewStarters(action);
        NewStarterStore.emit(appConstants.events.CHANGE);
        break;

    case appConstants.actions.NEW_STARTERS.GET_MORE_NEW_STARTERS:
        loadMoreNewStarters(action);
        NewStarterStore.emit(appConstants.events.CHANGE);
        break;

    case appConstants.actions.NEW_STARTERS.ADD_NEW_STARTER:
        addNewStarter(action);
        NewStarterStore.emit(appConstants.events.ADD_NEW_STARTER);
        break;

    case appConstants.actions.NEW_STARTERS.RESEND_FORMS_NEW_STARTER:
        resendForm(action);
        NewStarterStore.emit(appConstants.events.RESEND_FORMS_NEW_STARTER);
        break;
        
    case appConstants.actions.NEW_STARTERS.DELETE_NEW_STARTER:
        deleteNewStarter(action);
        NewStarterStore.emit(appConstants.events.DELETE_NEW_STARTER);
        break;

    case appConstants.actions.NEW_STARTERS.GET_NEW_STARTER:
        loadNewStarter(action);
        NewStarterStore.emit(appConstants.events.CHANGE);
        break;

    case appConstants.actions.NEW_STARTERS.UPDATE_NEW_STARTER:
        updateNewStarter(action);
        NewStarterStore.emit(appConstants.events.ADD_NEW_STARTER);
        break;

    case appConstants.actions.NEW_STARTERS.RESET_NEW_STARTER:
        resetNewStarter(action);
        NewStarterStore.emit(appConstants.events.CHANGE);
        break;

    case appConstants.actions.NEW_STARTERS.UPDATE_NEW_STARTER_STATUS:
        updateNewStarterStatus(action);
        NewStarterStore.emit(appConstants.events.CHANGE_NEW_STARTER_STATUS);
        break;

    case appConstants.actions.NEW_STARTERS.GET_NEW_STARTER_STATUS:
        getNewStarterStatus(action);
        NewStarterStore.emit(appConstants.events.CHANGE_NEW_STARTER_STATUS);
        break;

    case appConstants.actions.NEW_STARTERS.GET_NEW_STARTER_COMPLETED_PAGES:
        getNewStarterCompletedPages(action, action.queryParams);
        NewStarterStore.emit(appConstants.events.CHANGE_NEW_STARTER_COMPLETED_PAGES);
        break;

    case appConstants.actions.NEW_STARTERS.FINALISE_NEW_STARTER:
        updateNewStarter(action);
        NewStarterStore.emit(appConstants.events.ADD_NEW_STARTER);
        break;

    case appConstants.actions.NEW_STARTERS.GET_ACTION_REQUIRED_COUNT:
        getNewStarterActionCount(action);
        NewStarterStore.emit(appConstants.events.CHANGE_NEW_STARTER_ACTIONS_COUNT);
        break;

    default:
        return true;
    }

    return true;
});

export default NewStarterStore; 